import React from 'react';
import { Box } from '@mui/material';
import TopBar from "../../../../../../../component/TopBar";
import MainBox from "../../../../../container/MainBox";
import PolicyRules from '../../../../../../../component/PolicyRules';

const ExpensePolicyRules = () => {
  return (
    <Box sx={{ width: "100%" }}>
      <TopBar MainHeading={"Expense Policy"} breadcrumbs={[{ label: "Expense Policy", href: "/app/expense-policy/listing" }, { label: "Rules" }]} />
      <MainBox sx={{ padding: "2rem 1.25rem" }}>
        <PolicyRules
          addNewLink="/app/expense-policy/new/setting"
          viewAllLink="/app/expense-policy/listing"
          reviewLink="/app/expense-policy/new/review"
        />
      </MainBox>
    </Box>
  );
};

export default ExpensePolicyRules;
